import { BaseConfig } from './BaseConfig';
export class TableConfig {
  table: BaseConfig;
  columns: BaseConfig[];
  constructor(table: BaseConfig, columns: BaseConfig[]) {
    this.table = table;
    this.columns = columns;
  }
}
